import { WebApiResponse } from '../components/WebApi';

export const propagateWebApiState = (model: WebApiResponse) => {
  const TAB_SYNC_TRIGGER_EVENT_NAME = 'ssoui-webapi-trigger-event';
  const listenerFrame = (<HTMLIFrameElement>document.getElementById('sso.listener.iframe'))?.contentWindow;

  if (!!listenerFrame) {
    const tabId = (Math.random() + 1).toString(36).substring(7);
    const extendedModel = { ...model, key: TAB_SYNC_TRIGGER_EVENT_NAME, tabId };
    listenerFrame.postMessage(extendedModel, '*');
  }
};
